import React from 'react';
export const PainPoints = () => {
  const points = ['Llevás meses (o años) queriendo empezar en la brujería pero cada vez que buscás información, te abrumás y terminás sin hacer nada.', 'Buscás contenido online y lo que encontrás es contradictorio, en inglés o demasiado "new age" para tu estilo. Nada se siente como para vos.', 'Compraste un cuaderno lindo para hacer tu grimorio, escribiste 3 páginas... y ahí quedó. Porque no sabías qué más poner.', 'Sentís que las demás brujas saben algo que vos no. Que deberías saber más antes de empezar. Que quizás "no sos lo suficientemente espiritual".', 'Todo el material que encontrás está hecho para el hemisferio norte. Las lunas, las estaciones, las hierbas... nada coincide con tu realidad.'];
  return <section className="py-12 px-4 relative z-10" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <div className="text-center mb-8" data-id="element-119">
          <h2 className="font-cormorant text-4xl md:text-5xl text-gold-light mb-2" data-id="element-120">
            ¿Te suena familiar?
          </h2>
          <p className="text-xl text-text-soft font-outfit" data-id="element-121">
            Si sentís el llamado de la brujería, probablemente sí.
          </p>
        </div>

        <div className="space-y-3" data-id="element-122">
          {points.map((point, index) => <div key={index} className="surface-gradient border border-gold-dark/20 rounded-lg p-4 flex gap-4 items-start hover:border-gold-primary/50 transition-colors duration-300" data-id="element-123">
              <span className="font-cormorant text-3xl text-gold-dark font-bold leading-none mt-1" data-id="element-124">
                {index + 1}.
              </span>
              <p className="text-text-primary text-lg leading-relaxed" data-id="element-125">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};